"use client";
import { Card, Title, LineChart } from "@tremor/react";

const dataFormatter = (number: number) => {
  return number.toFixed(2);
};

export const LineChartDemo = ({ chartData, title }: any) => (
  <Card style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)' }}>
    <Title>{title}</Title>
    <LineChart
      className="mt-6"
      data={chartData}
      index="date"
      categories={["Number"]}
      colors={["blue"]}
      valueFormatter={dataFormatter}
      yAxisWidth={48}
      showXAxis={true}
      showYAxis={true}
      showLegend={true}
      showGridLines={true}
      showAnimation={true}
      autoMinValue={true}
      minValue={0}
      curveType="monotone"
    />
  </Card>
);